import { memo } from 'react';
import ThumbnailEvent from '../thumbnail/thumbnailEvent';
import useEventPreviewStrip from './useEventPreviewStrip';

export type EventPreviewStripProps = {
  id?: any;
  isSelected?: boolean;
  isActive?: boolean;
  sizeThumbnailConfig: any;
  event: any;
  overlayContent?: any;
  index?: any;
  onClickSelectEvent?: (event: any, index: any) => void;
};

/**
 * Renders one strip-management event thumbnail from the event record supplied in props. Pulls the click handler, the pending-change marker and the show-type flag from useEventPreviewStrip and forwards them to ThumbnailEvent alongside the selection and sizing props.
 *
 * @param props - The event record plus its id, selection state and thumbnail size config.
 * @returns The ThumbnailEvent thumbnail for this event.
 */
const EventPreviewStrip = ({
  id,
  isSelected,
  isActive,
  sizeThumbnailConfig,
  event,
  overlayContent,
  index,
  onClickSelectEvent,
}: EventPreviewStripProps) => {
  const { onClick, eleChange, showTypeEvent } = useEventPreviewStrip({
    event,
    overlayContent,
    index,
    onClickSelectEvent,
  });

  return (
    <ThumbnailEvent
      id={id}
      onClickSelect={onClick}
      isSelected={isSelected}
      isActive={isActive}
      isChanged={!!eleChange}
      sizeThumbnailConfig={sizeThumbnailConfig}
      event={event}
      showTypeEvent={showTypeEvent}
    />
  );
};

export default memo(EventPreviewStrip);
